import { useApi } from "@/api";
import { TicketListId } from "@/api/tickets";
import { defineQuery, defineQueryOptions, useQuery } from "@pinia/colada";
import { computed } from "vue";

export const TICKET_LIST_KEYS = {
    root: ["ticketLists"] as const,
    stubs: () => [...TICKET_LIST_KEYS.root, "stubs"] as const,
    detail: (id: TicketListId) => [...TICKET_LIST_KEYS.root, "detail", id] as const,
    permissions: (id: TicketListId) => [...TICKET_LIST_KEYS.root, "permissions", id] as const,
};

export const useTicketListStubs = defineQuery(() => {
    const { tickets } = useApi();
    const query = useQuery({
        key: TICKET_LIST_KEYS.stubs(),
        query: () => tickets.getLists(),
        staleTime: 0,
    });
    return { ...query, stubs: computed(() => query.state.value.data) };
});

export const ticketListDetailQuery = defineQueryOptions((id: TicketListId) => ({
    key: TICKET_LIST_KEYS.detail(id),
    query: () => useApi().tickets.getList(id),
    staleTime: 0,
}));

export const ticketListPermissionsQuery = defineQueryOptions((id: TicketListId) => ({
    key: TICKET_LIST_KEYS.permissions(id),
    query: () => useApi().tickets.getListPermissions(id),
    staleTime: 0,
}));
